
import { InfoCertificatoDTO } from "@app/shared/dto/protocollo/info-certificatoDTO";

export class InfoFirmaDTO {
certificateInfos:InfoCertificatoDTO[];
level: number;
signingTime:number;
}